module.exports = __webpack_public_path__ + "core-fonts/maxpro_s-light-webfont.65f23b0edd7a0f3c8ade7584cef0cc4d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/gfx/font/maxpro_s-light-webfont.ttf
// module id = 19
// module chunks = 0